<template>
    <ListenerAlbumLibrary v-if="isListenerMobile" />
    <AlbumLibrary v-else />
</template>

<script>
import AlbumLibrary from './AlbumLibrary.vue'
import ListenerAlbumLibrary from './ListenerAlbumLibrary.vue'

export default {
    name: 'albums',
    components: {
        AlbumLibrary,
        ListenerAlbumLibrary
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
